import cx from 'clsx';

import { BigSaleLabel } from '~/domains/plusMembership/components/BigSale/BigSaleLabel';
import { IS_BIG_SALE } from '~/domains/plusMembership/constants';

import { MembershipStandardWithWhiteText98x16Icon } from '~/assets/icons';
import { BonuspackClovercon } from '~/assets/icons/membership';

type Props = {
  type: string;
  description: string;
};

export function MembershipBenefitBanner({ type, description }: Props) {
  return (
    <div
      className={cx([
        'flex w-full items-center h-full justify-center gap-6 py-6',
        type === 'PLUS_MEMBERSHIP_WEEK' &&
          (IS_BIG_SALE
            ? 'bg-bigSale-background text-bigSale-text'
            : 'bg-plusmembership-event-badge text-inverse'),
        type === 'LUCKY_BONUS_PACK' &&
          'bg-bonuspackGreen-background text-inverse',
      ])}
    >
      {type === 'PLUS_MEMBERSHIP_WEEK' ? (
        IS_BIG_SALE ? (
          <BigSaleLabel />
        ) : (
          <MembershipStandardWithWhiteText98x16Icon />
        )
      ) : (
        <BonuspackClovercon />
      )}
      <p className="typo-paragraph100-semibold">{description}</p>
    </div>
  );
}
